import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as Background } from "assets/icons/bg.svg";

const DataNotFound = ({ message = "No Results Found" }) => {
  const keyword = message.match(/"(.+)"/)?.[1];
  const baseText = keyword ? message.replace(`"${keyword}"`, "").trim() : message;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        width: "100%",
        gap: "0px",
        mt: "40px"
      }}
    >
      {/* Logo with glow ring */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: "28px",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(80,200,120,0.12) 0%, rgba(80,200,120,0.04) 50%, transparent 70%)",
            filter: "blur(12px)",
          }}
        />
        <Box sx={{ opacity: 0.55, transform: "scale(1.1)" }}>
          <Background />
        </Box>
      </Box>

      {/* Main message */}
      <Typography
        sx={{
          color: "#ffffff",
          fontFamily: "Poppins",
          fontSize: "22px",
          fontWeight: 600,
          letterSpacing: "0.3px",
          mb: "8px",
        }}
      >
        {baseText}
      </Typography>

      {/* Keyword highlight */}
      {keyword && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            mb: "20px",
          }}
        >
          <Box sx={{ width: "28px", height: "1.5px", backgroundColor: "#50C878", borderRadius: "2px" }} />
          <Typography
            sx={{
              color: "#50C878",
              fontFamily: "Poppins",
              fontSize: "15px",
              fontWeight: 500,
              fontStyle: "italic",
              letterSpacing: "0.4px",
            }}
          >
            "{keyword}"
          </Typography>
          <Box sx={{ width: "28px", height: "1.5px", backgroundColor: "#50C878", borderRadius: "2px" }} />
        </Box>
      )}

      {/* Hint text */}
      <Typography
        sx={{
          color: "#6B6B6B",
          fontFamily: "Poppins",
          fontSize: "13px",
          fontWeight: 400,
          letterSpacing: "0.2px",
        }}
      >
        Try a different search term or clear filters
      </Typography>
    </Box>
  );
};

export default DataNotFound;
